import { render, staticRenderFns } from "./FooterContacts.vue?vue&type=template&id=7930113d&"
import script from "./FooterContacts.vue?vue&type=script&lang=js&"
export * from "./FooterContacts.vue?vue&type=script&lang=js&"
import style0 from "./FooterContacts.vue?vue&type=style&index=0&id=7930113d&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports